import { useState, useEffect, useRef } from 'react';
import { useFormik, FieldArray, Formik } from 'formik';
import { useHistory } from 'react-router-dom'


// import { useSelector } from 'react-redux';
import s from './docs.module.css'
// import SaveStatus from '../../UIComponents/SaveStatus'
import { DataGrid } from '@mui/x-data-grid';
import { Button, Typography, TextField } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import Paper from '@mui/material/Paper';
// import DatePickerFormik from '../../UIComponents/DatePickerFormik'
import DatePicker from '../../UIComponents/DatePicker'
/**добавить заказ-наряд для этих работ*/
import PostAddIcon from '@mui/icons-material/PostAdd';

import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import PreviewIcon from '@mui/icons-material/Preview';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SaveStatus from '../../UIComponents/SaveStatus';

import DirectorySelect from '../../UIComponents/DirecttorySelect'

import useStyles from './useStyles';

import mapStateToProps from './mapStateToProps'


const WorkOrderEditor = (props) => {
  const {
    variant = 'view',
    saver = () => { },
    fields,
    rights,
    planWorkArr = [],
    defaultFrom = new Date().valueOf,
    defaultTo = new Date().valueOf,
    addingDocument,
    savingDocument,
    postSaveAction = () => { },
  } = props


  const ro = variant === 'view'

  const history = useHistory()

  // const { values, handleSubmit, handleChange, setFieldValue } = useFormik({
  //     initialValues: fields,
  //     onSubmit: saver,
  // })

  let title = 'Просмотр';
  if (variant === 'edit') {
    title = 'Редактирование';
  } else if (variant === 'add') {
    title = 'Добавление';
  }

  const getFrom = (id) => getPW(id)?.start?.rawValue || defaultFrom;
  const getTo = (id) => getPW(id)?.end?.rawValue || defaultFrom;
  const getScope = (id) => getPW(id)?.scope?.rawValue || 0;

  const getPW = (id) => {
    return planWorkArr?.find(({ workType }) => workType?.rawValue === id)
  }

  const onCancel = () => {
    history.push('/document/work-order')
  }


  return (
    <div className={s.docsContainer} style={{ width: "100%" }}>
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>
          <Typography variant='h6'>{title}</Typography>
        </div>
      </div>
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>
          <Formik
            initialValues={fields}
            onSubmit={saver}
          >
            {({ values, handleSubmit, handleChange, setFieldValue }) => {

              const updateTeam = (index, e) => {
                const teams = values?.dataArr?.map(({ team }, i) => (i === index ? e?.target?.value : team))
                  ?.reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], [])
                  ?.filter(i => !!i)
                  ?.join();
                setFieldValue('teams', teams)

              }
              const updatePerformers = (index, value) => {
                setFieldValue(`dataArr[${index}].worker`, value)

                const performers = values?.dataArr?.map(({ worker }, i) => (i === index ? value : worker))
                  ?.reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], [])
                  ?.filter(i => !!i)
                  //Здесь должна быть еще одна мапилка, которая будет разрешать ид работников в имена
                  ?.join();
                setFieldValue('performers', performers)
              }
              return (

                <form onSubmit={handleSubmit}>
                  <Typography variant="caption">
                    Номер
                  </Typography>
                  <TextField
                    name="number"
                    disabled={true}
                    value={values?.number}
                    onChange={handleChange}
                    size='small'
                    fullWidth
                  />
                  <DirectorySelect
                    name="company"
                    disabled={true}
                    value={values?.company}
                    onChange={v => setFieldValue('company', v)}
                    label="Компания"
                    dirName="companies"
                  />
                  <DirectorySelect
                    name="plan"
                    disabled={true}
                    value={values?.plan}
                    label="План-график"
                    dirName="documents-planSchedule"
                  />
                  <DirectorySelect
                    name="workType"
                    disabled={variant !== 'edit'}
                    value={values?.workType}
                    onChange={v => {
                      setFieldValue('workType', v)
                      setFieldValue('periodFrom', getFrom(v))
                      setFieldValue('periodTo', getTo(v))
                    }}
                    label="Вид работ"
                    disableGetting={true}
                    dirName="planWorkDir"
                  />
                  <DirectorySelect
                    name="project"
                    disabled={true}
                    value={values?.project}
                    onChange={v => setFieldValue('project', v)}
                    label="Проект"
                    dirName="projects"
                  />
                  <Typography variant="caption">
                    Период с
                  </Typography>
                  <div style={{ width: "100%" }}>
                    <DatePicker
                      name="periodFrom"
                      disabled={values?.isView}
                      value={values?.periodFrom}
                      onChange={v => setFieldValue('periodFrom', v?.valueOf())}
                      size='small'
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                  <Typography variant="caption">
                    По
                  </Typography>
                  <div style={{ width: "100%" }}>
                    <DatePicker
                      name="periodTo"
                      disabled={values?.isView}
                      value={values?.periodTo}
                      onChange={v => setFieldValue('periodTo', v?.valueOf())}
                      size='small'
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                  <Typography variant="caption">
                    Исполнинели (заполняется автоматически)
                  </Typography>
                  <TextField
                    name="period"
                    disabled={true}
                    value={values?.performers}
                    size='small'
                    fullWidth
                  />
                  <Typography variant="caption">
                    Бригады (заполняется автоматически)
                  </Typography>
                  <TextField
                    name="period"
                    disabled={true}
                    value={values?.teams}
                    size='small'
                    fullWidth
                  />
                  <Typography variant="caption">
                    Дата
                  </Typography>
                  <div style={{ width: "100%" }}>
                    <DatePicker
                      name="date"
                      disabled={values?.isView}
                      value={values?.date}
                      onChange={v => setFieldValue('date', v?.valueOf())}
                      size='small'
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                  <Typography variant="caption">
                    Статус
                  </Typography>
                  <TextField
                    name="demoStatus"
                    disabled
                    value={values?.demoStatus}
                    onChange={handleChange}
                    size='small'
                    fullWidth
                  />
                  <Typography variant="caption">
                    Подготовил
                  </Typography>
                  <TextField
                    name="preparedBy"
                    disabled
                    value={values?.preparedBy}
                    onChange={handleChange}
                    size='small'
                    fullWidth
                  />
                  <DirectorySelect
                    name="geozone"
                    disabled={values?.isView}
                    value={values?.geozone}
                    onChange={v => setFieldValue('geozone', v)}
                    label="Геозона"
                    dirName="geozones"
                  />
                  <FormControlLabel
                    label="Проведен"
                    control={<Checkbox disabled={values?.isView} name="carriedOut" checked={values?.carriedOut} onChange={handleChange} />}
                  />
                  {/*
                    carriedOut,
                  */}
                  <div style={{ width: "100%", marginBottom: "10px" }}>
                    <FieldArray
                      name='dataArr'
                      validateOnChange={false}
                      render={({ push, remove }) => (
                        <>
                          <TableContainer component={Paper}>
                            <TableHead>
                              <TableRow>
                                {/* 
                                id,
                                number,
                                order,
                                worker,
                                team,
                                tracker,
                                scopePlan,
                                scopeFact,
                                startDate,
                                endDate,
                                planedStartDate,
                                planedEndDate,
                                note,
                                */}
                                <TableCell>Nпп</TableCell>
                                <TableCell>Исполнитель</TableCell>
                                <TableCell>Бригада</TableCell>
                                <TableCell>Трекер</TableCell>
                                <TableCell>Начало работ план.</TableCell>
                                <TableCell>Окончание работ план.</TableCell>
                                <TableCell>Объем работ план.</TableCell>
                                <TableCell>Начало работ факт.</TableCell>
                                <TableCell>Окончание работ факт.</TableCell>
                                <TableCell>Объем работ факт.</TableCell>
                                <TableCell>Примечание</TableCell>
                                <TableCell>Действия</TableCell>
                              </TableRow>
                            </TableHead>
                            {(values?.dataArr && values?.dataArr?.length > 0) ? (
                              values.dataArr.map((item, index) => {
                                const {
                                  // id,
                                  number,
                                  // order,
                                  worker,
                                  team,
                                  tracker,
                                  scopePlan,
                                  scopeFact,
                                  startDate,
                                  endDate,
                                  planedStartDate,
                                  planedEndDate,
                                  note,
                                } = item;

                                return (
                                  <TableRow>
                                    <TableCell>
                                      <TextField
                                        name={`dataArr[${index}].number`}
                                        disabled={values?.isView}
                                        value={number}
                                        onChange={handleChange}
                                        size='small'
                                        fullWidth
                                      />
                                    </TableCell>
                                    <TableCell >
                                      <DirectorySelect
                                        sx={{ width: "200px" }}
                                        name={`dataArr[${index}].worker`}
                                        disabled={values?.isView}
                                        value={worker}
                                        onChange={v => {
                                          updatePerformers(index, v)
                                        }}
                                        hideLabel={true}
                                        fullWidth
                                        dirName="workers"
                                      />
                                    </TableCell>
                                    <TableCell >
                                      <TextField
                                        name={`dataArr[${index}].team`}
                                        disabled={values?.isView}
                                        value={team}
                                        onChange={(e, v) => {
                                          handleChange(e)
                                          updateTeam(index, e)
                                        }}
                                        size='small'
                                        fullWidth
                                      />
                                    </TableCell>
                                    <TableCell >
                                      <DirectorySelect
                                        sx={{ width: "200px" }}
                                        name={`dataArr[${index}].tracker`}
                                        disabled={values?.isView}
                                        value={tracker}
                                        onChange={v => setFieldValue(`dataArr[${index}].tracker`, v)}
                                        hideLabel={true}
                                        fullWidth
                                        dirName="trackers"
                                      />
                                    </TableCell>
                                    <TableCell >
                                      <DatePicker
                                        name={`dataArr[${index}].planedStartDate`}
                                        disabled={values?.isView}
                                        value={planedStartDate}
                                        onChange={v => setFieldValue(`dataArr[${index}].planedStartDate`, v?.valueOf())}
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                      />
                                    </TableCell>
                                    <TableCell >
                                      <DatePicker
                                        name={`dataArr[${index}].planedEndDate`}
                                        disabled={values?.isView}
                                        value={planedEndDate}
                                        onChange={v => setFieldValue(`dataArr[${index}].planedEndDate`, v?.valueOf())}
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <TextField
                                        name={`dataArr[${index}].scopePlan`}
                                        disabled={values?.isView}
                                        value={scopePlan}
                                        onChange={handleChange}
                                        size='small'
                                        fullWidth
                                      />
                                    </TableCell>


                                    {/* <TableCell>Начало работ план.</TableCell>
                                      <TableCell>Окончание работ план.</TableCell>
                                      <TableCell>Объем работ план.</TableCell>
                                      <TableCell>Начало работ факт.</TableCell>
                                      <TableCell>Окончание работ факт.</TableCell>
                                      */}

                                    <TableCell >
                                      <DatePicker
                                        name={`dataArr[${index}].startDate`}
                                        disabled={values?.isView}
                                        value={startDate}
                                        onChange={v => setFieldValue(`dataArr[${index}].startDate`, v?.valueOf())}
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                      />
                                    </TableCell>
                                    <TableCell >
                                      <DatePicker
                                        name={`dataArr[${index}].endDate`}
                                        disabled={values?.isView}
                                        value={endDate}
                                        onChange={v => setFieldValue(`dataArr[${index}].endDate`, v?.valueOf())}
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <TextField
                                        name={`dataArr[${index}].scopeFact`}
                                        disabled
                                        value={scopeFact}
                                        onChange={handleChange}
                                        size='small'
                                        fullWidth
                                      />
                                    </TableCell>

                                    <TableCell >
                                      <TextField
                                        name={`dataArr[${index}].note`}
                                        disabled={values?.isView}
                                        value={note}
                                        onChange={handleChange}
                                        size='small'
                                        fullWidth
                                      />
                                    </TableCell>
                                    <TableCell align="right">

                                      <Button
                                        color="error"
                                        variant="contained"
                                        disabled={values?.isView}
                                        onClick={() => remove(index)}
                                      >
                                        Удалить
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                )
                              })
                            ) : null}
                            {values?.isView ? null : (
                              <TableFooter>
                                <TableRow>
                                  <TableCell></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right"></TableCell>
                                  <TableCell align="right">
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      disabled={values?.isView}
                                      onClick={() => push({
                                        // id,
                                        number: '',
                                        worker: undefined,
                                        team: '',
                                        tracker: undefined,
                                        scopePlan: getScope(values?.workType || 'NEH'),
                                        scopeFact: '',
                                        startDate: getFrom(values?.workType || 'NEH'),
                                        endDate: getTo(values?.workType || 'NEH'),
                                        planedStartDate: getFrom(values?.workType || 'NEH'),
                                        planedEndDate: getTo(values?.workType || 'NEH'),
                                        note: '',
                                      })}
                                    >
                                      Добавить
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              </TableFooter>
                            )}
                          </TableContainer>


                        </>
                      )}
                    />
                  </div>
                  <SaveStatus dataObj={addingDocument} postSuccessAction={postSaveAction} errShowTime={1000} successShowTime={100} />
                  <SaveStatus dataObj={savingDocument} postSuccessAction={postSaveAction} errShowTime={1000} successShowTime={100} />
                  <Button color="primary" variant="contained" type="submit" disabled={ro}>
                    Сохранить
                  </Button>
                  <Button color="primary" variant="outlined" onClick={onCancel}>
                    Отмена
                  </Button>
                </form>
              )
            }}
          </Formik>
        </div>
      </div >
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>

        </div>
        {/* <BodyRight /> */}
      </div>

    </div >
  );
};



export default WorkOrderEditor;